//描述：二维码弹窗控制器
//作者：baizhiming
//时间：2017-1-19
"use strict";
angular.module("qrCodeModule", [])
    .controller("qrCodeCtrl", ["$scope", "$modalInstance", "$timeout", "inputStringvar", function($scope, $modalInstance, $timeout, inputStringvar) {
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        
        try {
           init(); 
        } catch (e){
            LazyLoad.js(["./lib/qrcodejs/qrcode.min.js"],function(){
                init();
            });
        }
        
        function init() {
            var dom = document.createElement("div");
            var qrcoder = new QRCode(dom);
            qrcoder.makeCode(inputStringvar);
            $timeout(function() {
                $scope.qrCodeUrl = $(dom).find("img").attr("src");
            });
        }
        /*var deffer = $q.defer();
                    var dom = document.createElement("div");
                    var qrcoder = new QRCode(dom);
                    qrcoder.makeCode(inputStringvar);
                    setTimeout(function() {
                        var imgData = $(dom).find("img").attr("src");
                        deffer.resolve(imgData);
                    }, 1000);
                    return deffer.promise;*/
    }]);
